import { render, staticRenderFns } from "./ProductsAdmin.vue?vue&type=template&id=12f8cdf2"
import script from "./ProductsAdmin.vue?vue&type=script&lang=ts"
export * from "./ProductsAdmin.vue?vue&type=script&lang=ts"
import style0 from "./ProductsAdmin.vue?vue&type=style&index=0&id=12f8cdf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports